<template>
    <div v-if="notices.length > 0">
      <span v-for="(notice, index) in notices" :key="index">
       <v-chip v-if="!notice.surface" :color="notice.type ?? 'primary'" rounded
               :density="notice.density ?? 'compact'">
                  {{ notice.message ?? notice }}
                </v-chip>
        <span v-else>
          {{notice.message ?? notice }}
        </span>
      </span>
    </div>
</template>
<script setup lang="ts">
import {Notice} from "@/lib/keys";
import {computed} from "vue";

interface Props {
  location: string;
  all: Notice[];
}

const props = withDefaults(defineProps<Props>(), {})


const notices = computed(() => props.all.filter(
    notice => notice.location
        ? notice.location === props.location
        : props.location === 'default'
))
</script>
